import { H } from "react-router/dist/development/route-data-B9_30zbP";
import { NoteSelectionGroup } from "./NoteSelectionGroup";
import { HorizontalContainer, HorizontalNoteContainer } from "../model/containers";

// T is expected to be literal union type.
export type Transition<T> = () => T;
class AbstractStateMachine<T> {
    protected currentState: T;

    constructor(initialState: T) {
        this.currentState = initialState;
    }

    transition(evaluate: Transition<T>): void {
        this.currentState = evaluate();
    }

    getState(): T {
        return this.currentState;
    }
}

export type CopyBufferState = "COPY_ON_BUFFER"
    | "DROP_PREPARE"
    | "COPY_ON_CONTAINER";

export type CopyBufferTransition = Transition<CopyBufferState>;

export class CopyBuffer extends AbstractStateMachine<CopyBufferState> {
    constructor(
        private selection: NoteSelectionGroup
    ) {
        super("COPY_ON_BUFFER");

    }
    getSelection(): NoteSelectionGroup {
        return this.selection;
    }
}
